import React from 'react';

const HTMLViewer = ({ htmlContent }) => {
    return (
        <div className="html-viewer" dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
};

export default HTMLViewer;
